<template>
  <div class="ChannelBox">
    <Nav />
    <div class="Channel">
			<Banner :location="4" />
			<!-- center -->
			<div class="_cont">
				<div class="_topTitle">
					<p>我们将为贵公司提供一对一的专业服务并赠送100-10000元。 </p>
					<p>信息提交后1小时内，我们将安排专员为贵司回访，为了确保尽快获得联系，请如实填写您的信息。</p>
				</div>
				<div class="_fromBox">
					<h3>填写企业信息</h3>
					<el-form class="_form" ref="sizeForm" :rules="rules" :model="sizeForm" label-width="120px" size="mini">
						<!-- <el-form-item label="活动性质">
							<el-checkbox-group v-model="sizeForm.type">
								<el-checkbox-button label="美食/餐厅线上活动" name="type"></el-checkbox-button>
								<el-checkbox-button label="地推活动" name="type"></el-checkbox-button>
								<el-checkbox-button label="线下主题活动" name="type"></el-checkbox-button>
							</el-checkbox-group>
						</el-form-item> -->
					
						<el-form-item label="注册资金" prop="regist_capital" >
							<el-radio-group v-model="sizeForm.regist_capital" size="medium">
								<el-radio border label="10-500万"></el-radio>
								<el-radio border label="500-1000万"></el-radio>
								<el-radio border label="1000-5000万"></el-radio>
								<el-radio border label="5000万以上"></el-radio>
								<el-radio border label="上市公司"></el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="企业名称" prop="name">
							<el-input v-model="sizeForm.name" placeholder="请输入企业名称"></el-input>
						</el-form-item>
						<el-form-item label="联系人姓名" prop="link_name">
							<el-input v-model="sizeForm.link_name" placeholder="请输入联系人姓名"></el-input>
						</el-form-item>
						<el-form-item label="联系人手机号" prop="link_phone">
							<el-input type="number" v-model="sizeForm.link_phone" placeholder="请输入联系人手机号"></el-input>
						</el-form-item>
						<el-form-item label="用途">
							<el-input v-model="sizeForm.purpose" placeholder="请输入用途"></el-input>
						</el-form-item>
						<el-form-item size="large">
							<el-button type="primary" @click="onSubmit('sizeForm')">提交</el-button>
							<!-- <el-button>取消</el-button> -->
						</el-form-item>
					</el-form>
				</div>
			</div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { WOW } from 'wowjs' 
import Foot from '@/components/Foot.vue'
import Banner from '@/components/Banner.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
  name: 'Channel',
  components: {
    Nav,
    Foot,
    Banner
  },
  data(){
    return {
			sizeForm: {
				regist_capital: '',
				name: '',
				link_phone: '',
				link_name: '',
				purpose: '',
			},
			isSubmitting: false, // 防抖标志
			rules:{
				regist_capital:[
					{ required: true, message: '请选择注册资金', trigger: 'change' }
				],
				name:[
					{ required: true, message: '请输入企业名称', trigger: 'blur' },
				],
				link_name:[
					{ required: true, message: '请输入联系人姓名', trigger: 'blur' },
				],
				link_phone:[
					{ required: true, message: '请输入联系人手机号', trigger: 'blur' },
				]
			}
    }
  },
  methods:{
    onSubmit(formName) {
			// 防抖：如果正在提交，直接返回
			if (this.isSubmitting) {
				this.$message.warning('请勿重复提交')
				return
			}
			
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 设置提交中状态
					this.isSubmitting = true
					// 提交时不传 token
					let data = { ...this.sizeForm }
					console.log('提交数据:', data)
					request({
						method: "post", 
						url: Apis.enterprise,
						params:data,
						_type:1,
					}).then(res => {
						if(res.code == 0){
							this.$message({
								message: res.data,
								showClose: true,
								duration:1500,
								type: 'success'
							});
							// 提交成功后清空表单
							this.sizeForm = {
								regist_capital: '',
								name: '',
								link_phone: '',
								link_name: '',
								purpose: '',
							}
						}else{
							this.$message.error(res.msg);
						}
					}).finally(() => {
						// 无论成功失败，都重置提交状态
						this.isSubmitting = false
					});
				} else {
					return false;
				}
			});
			
		}
  }
}
</script>

<style lang="less" scoped>
.ChannelBox{
  width: 100%;
	min-height: 800px;
	.Channel{
		.banner{
			width: 100%;
			height: 260px;
			// background: url('../assets/banner_2.png')no-repeat;
			background-size: 100% 100%;
			h1,h3{
				width: 100%;
				color: #fff;
				text-align: center;  
				text-shadow: -2px 2px 0px #2a4fe4;
			}
			h1{
				font-size: 36px;
				font-weight: bold;
				padding-top: 85px;
			}
			h3{
				font-size: 16px;
				padding-top: 10px;
			}
		}
		._cont{
			width: 100%;
			._topTitle{
				width: 100%;
				font-size: 20px;
				font-weight: bold;
				color: #1E1D1D;
				margin-top: 95px;
			}
			._fromBox{
				width: 1200px;
				margin: 0 auto;
				h3{
					font-size: 24px;
					color: #1E1D1D;
					margin-top: 58px;
				}
				._form{
					width: 850px;
					margin: 0 auto;
					margin-top: 54px;
					font-size: 20px;
					text-align: left;
					// display: flex;
				}
			}
		}
	}
}
 @media screen and (max-width: 1200px) {
    .ChannelBox{
    }
  }
</style>
<style scoped>
._form >>> .el-radio{
	margin-right: 0px;
}
._form >>> .el-input__inner{
	width: 80%;
}
._form >>> .el-button{
	margin-left: 36%;
}
</style>